import React from "react";
import {DatePicker} from "@mui/x-date-pickers";
import {useTranslation} from "react-i18next";


const DateGte = ({dateGte, setDateGte, maxDate, ...props}) => {
    const {t} = useTranslation("inputs");

    return <DatePicker label={t("dateGte.label")}
                       value={dateGte}
                       onChange={(newValue) => {
                           if (newValue && !isNaN(newValue.getTime())) {
                               setDateGte(newValue);
                           }
                       }}
                       slotProps={{textField: {variant: "standard", placeholder: t("dateGte.placeholder"), fullWidth: true}}}
                       maxDate={maxDate}
                       {...props}
    />
}

export default DateGte;